import { BackOfficeDtoConverter } from 'shared/services/backoffice-data-provider';

import { AppAdmin } from './models/Admin.model';

export class AdminDtoConverter extends BackOfficeDtoConverter {
  convert(dto: any) {
    return AppAdmin.fromDto(dto) as any;
  }
}
